<ng-container *ngIf="currentPanel === 'main'">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-group" [class.mb-10]="isLogo.value" [class.mb-20]="!isLogo.value">
                <label class="col-xs-9 control-label">
                    {{ "control_add_logo" | translate }}
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="isLogo.value" (toggleActiveEvent)="toggleLogo($event)"> </sp-switch>
                </div>
            </div>

            <div *ngIf="isLogo.value">
                <div class="mb-20">
                    <sp-file-manager
                        [fmSourceType]="fmSourceType.LANDING"
                        [disabled]="buttonDisabled"
                        [file]="uploadImage.value"
                        [displayOnly]="[DirectoryItemCategory.Image]"
                        (setFileEvent)="setUploadImage($event)"
                        (replaceFileEvent)="replaceUploadImage($event)"
                    >
                        <sp-defautl-upload-button
                            *ngIf="!uploadImage.value"
                            stockImagesDropdown
                            [disabled]="buttonDisabled"
                            (unsplashRequested)="openUnsplashModal()"
                        ></sp-defautl-upload-button>

                        <ng-template
                            #previewTemplate
                            let-file="file"
                            let-replaceFileFn="replaceFileFn"
                            let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                        >
                            <div class="mb-20">
                                <sp-files-select
                                    #ref
                                    toggless
                                    (myPhotosClick)="replaceFileFn()"
                                    (unsplashClick)="openUnsplashModal()"
                                >
                                    <sp-control-handle
                                        [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                        [controlHandleMainText]="file.name"
                                        (editActionEvent)="editImage(file)"
                                        (removeActionEvent)="removeFile()"
                                        (replaceActionEvent)="ref.dp.toggle()"
                                        (imageEditEvent)="showEditImageModal()"
                                        [isDisableEditor]="(userId$ | async) !== imageOwnerUserId"
                                    ></sp-control-handle>
                                </sp-files-select>
                            </div>
                        </ng-template>
                    </sp-file-manager>

                    <div *ngIf="uploadImage.value" class="form-group mb-20">
                        <label class="control-label col-xs-6">
                            {{ "control_width" | translate }}
                            <small [tooltip]="logoWidthTooltip" class="sp-icon icon-info-bold color-light"> </small>
                            <ng-template #logoWidthTooltip>
                                {{ "logo_width_tooltip" | translate }}
                            </ng-template>
                        </label>
                        <div class="col-xs-6 img-width-control">
                            <img
                                *ngIf="refreshButtonState"
                                class="refresh-width-btn"
                                [tooltip]="refreshLogoWidthTooltip"
                                (click)="refreshImageWidth()"
                                src="./assets/img/websites/lpc-return-icon.svg"
                            />
                            <ng-template #refreshLogoWidthTooltip>
                                {{ "refresh_width_tooltip" | translate }}
                            </ng-template>
                            <sp-input-num
                                [min]="1"
                                [max]="logoMaxWidthValue"
                                [value]="logoWidth.value"
                                (valueChange)="setLogoWidth($event)"
                                suffixText="px"
                            ></sp-input-num>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group mb-0">
                <label class="col-xs-6">
                    {{ "control_menu_items" | translate }}
                </label>
                <div class="col-xs-6">
                    <a class="dotted pull-right" (click)="editMenuStyle()">{{ "control_menu_styles" | translate }}</a>
                </div>
            </div>

            <div class="mb-0" cdkDropList [cdkDropListData]="menuList" (cdkDropListDropped)="dropMenuItem($event)">
                <div
                    *ngFor="let menuItem of menuList.value; let i = index; trackBy: trackIndex"
                    cdkDrag
                    cdkDropListGroup
                    [cdkDragData]="menuItem"
                >
                    <sp-control-handle
                        [controlHandleBtn]="menuList.length === 1 ? false : true"
                        [controlHandleDisableDelete]="menuList.length === 1"
                        [controlHandleCheckbox]="true"
                        [controlHandleCheckboxChecked]="menuItem.isVisible"
                        [controlHandleMainText]="menuItem.name"
                        [controlHandleSubText]="menuItem.linkUrl"
                        [controlHandleDropdownActionList]="[
                            controlHandleEvents.copy,
                            controlHandleEvents.addSubMenu,
                            controlHandleEvents.delete,
                        ]"
                        (editActionEvent)="editMenuItem(menuItem, i)"
                        (copyActionEvent)="copyMenuItem(menuItem, i)"
                        (addSubMenuEvent)="addSubmenuItem(i)"
                        (removeActionEvent)="removeMenuItem(i)"
                        (toggleCheckBoxEvent)="changeMenuItemVisibility(i)"
                    >
                        <span cdkDragHandle></span>
                    </sp-control-handle>
                    <div
                        class="submenu-item-list"
                        [ngClass]="{ 'mb-15': menuItem.submenuList?.length }"
                        cdkDropList
                        [cdkDropListData]="menuItem.submenuList"
                        (cdkDropListDropped)="dropSubmenuItem($event, menuItem, i)"
                    >
                        <div
                            class="submenu-item"
                            *ngFor="let submenuItem of menuItem.submenuList; let i = index; trackBy: trackIndex"
                            cdkDrag
                            cdkDropListGroup
                            [cdkDragData]="submenuItem"
                        >
                            <sp-control-handle
                                [controlHandleBtn]="menuItem.submenuList.length === 1 ? false : true"
                                [controlHandleDisableDelete]="menuItem.submenuList.length === 1"
                                [controlHandleCheckbox]="true"
                                [controlHandleCheckboxChecked]="submenuItem.isVisible"
                                [controlHandleMainText]="submenuItem.name"
                                [controlHandleSubText]="submenuItem.linkUrl"
                                [controlHandleDropdownActionList]="[
                                    controlHandleEvents.copy,
                                    controlHandleEvents.delete,
                                ]"
                                (editActionEvent)="editSubmenuItem(menuItem, submenuItem, i)"
                                (copyActionEvent)="copySubmenuItem(menuItem, submenuItem, i)"
                                (removeActionEvent)="removeSubmenuItem(menuItem, i)"
                                (toggleCheckBoxEvent)="changeSubmenuItemVisibility(menuItem, submenuItem, i)"
                            >
                                <span cdkDragHandle></span>
                            </sp-control-handle>
                            <div class="item-dnd-placeholder" *cdkDragPlaceholder></div>
                        </div>
                    </div>
                    <div class="item-dnd-placeholder" *cdkDragPlaceholder></div>
                </div>

                <a class="dotted" (click)="addMenuItem()">{{ "add" | translate }}</a>
            </div>

            <div class="form-group mb-10 mt-20">
                <div class="col-xs-12 device-toggle-wrapper">
                    <web-device-toggle></web-device-toggle>

                    <web-synchronize-style-toggle
                        [active]="isSynchronizeStyle.value"
                        (click)="setSynchronizeStyle()"
                    ></web-synchronize-style-toggle>
                </div>
            </div>

            <div class="form-group mb-0">
                <ng-container *ngIf="isDeviceDesktop$ | async">
                    <p class="col-xs-12 help-block text-muted small">
                        {{ "desktop_device_hint" | translate }}
                    </p>
                </ng-container>

                <ng-container *ngIf="isDeviceTablet$ | async">
                    <p class="col-xs-12 help-block text-muted small">
                        {{ "tablet_device_hint" | translate }}
                    </p>
                </ng-container>

                <ng-container *ngIf="isDeviceMobile$ | async">
                    <p class="col-xs-12 help-block text-muted small">
                        {{ "mobile_device_hint" | translate }}
                    </p>
                </ng-container>
            </div>

            <div>
                <web-widget-position-settings
                    [isSynchronized]="isSynchronizeStyle.value"
                    [isTablet]="isDeviceTablet$ | async"
                    [isMobile]="isDeviceMobile$ | async"
                    [widgetId]="widget.id"
                    [columnId]="widget.columnId"
                    [position]="position.value"
                    (positionChange)="position.patchValue($event)"
                ></web-widget-position-settings>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <web-widget-hide-settings
                    [hideOnDesktop]="hideOnDesktop.value"
                    [hideOnTablet]="hideOnTablet.value"
                    [hideOnMobile]="hideOnMobile.value"
                    (hideOnDesktopChange)="hideOnDesktop.setValue($event)"
                    (hideOnTabletChange)="hideOnTablet.setValue($event)"
                    (hideOnMobileChange)="hideOnMobile.setValue($event)"
                ></web-widget-hide-settings>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
            </div>

            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="currentPanel === 'item-settings'">
    <web-menu-settings
        [item]="editableMenuItem"
        (saveEvent)="saveMenuItem($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-menu-settings>
</ng-container>

<ng-container *ngIf="currentPanel === 'submenu-item-settings'">
    <web-menu-settings
        [item]="editableSubmenuItem"
        (saveEvent)="saveSubmenuItem($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-menu-settings>
</ng-container>

<ng-container *ngIf="currentPanel === 'style-settings'">
    <web-style-settings
        [item]="editableMenuStyle"
        (saveEvent)="saveMenuStyle($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-style-settings>
</ng-container>

<ng-container *ngIf="currentPanel === 'logo-settings'">
    <web-logo-settings
        [item]="editableLogo"
        (saveEvent)="saveLogoSettings($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-logo-settings>
</ng-container>
